import React from 'react';
import { Checkbox, Paper, Stack, Typography } from '@mui/material';
import { Square as SquareIcon } from '@mui/icons-material';
import { defineMessages, useIntl } from 'react-intl';
import { Palette } from './Palette';
import useMonitorMap from './useMonitorMap';
const msgs = defineMessages({
    textFootprint: {
        id: 'map.MapLegend.text.footprint',
        defaultMessage: 'Footprint',
    },
    textRadar: {
        id: 'map.MapLegend.text.radar',
        defaultMessage: 'Radar',
    },
    textFlightPath: {
        id: 'map.MapLegend.text.flightPath',
        defaultMessage: 'Flight path',
    },
    textGeoFence: {
        id: 'map.MapLegend.text.geoFence',
        defaultMessage: 'Geo fence',
    },
    textSafePort: {
        id: 'map.MapLegend.text.safePort',
        defaultMessage: 'Safe port',
    },
    textNoFlyZone: {
        id: 'map.MapLegend.text.noFlyZone',
        defaultMessage: 'No-fly zone',
    },
});
function Row({ color, label, fill, enabled = true, onToggle }) {
    return (React.createElement(Stack, { gap: 1 / 2, direction: "row", onClick: onToggle, sx: { alignItems: 'center', cursor: onToggle ? 'pointer' : 'default', opacity: enabled ? 1 : 0.45 } },
        React.createElement(Checkbox, { size: "small", checked: enabled, readOnly: true, tabIndex: -1, sx: { p: 0, pointerEvents: 'none' }, icon: React.createElement(SquareIcon, { fontSize: "small", style: {
                    fillOpacity: 0.5,
                    fill: fill ? color : undefined,
                    stroke: color,
                    color: 'transparent',
                    strokeWidth: 3,
                } }), checkedIcon: React.createElement(SquareIcon, { fontSize: "small", style: {
                    fillOpacity: 0.5,
                    fill: fill ? color : undefined,
                    stroke: color,
                    color: 'transparent',
                    strokeWidth: 3,
                } }) }),
        React.createElement(Typography, { variant: "caption", sx: { lineHeight: 0 } }, label)));
}
function MapLegend({ enableRadar, interactive = false }) {
    const intl = useIntl();
    const { showFootprint, setShowFootprint, showRadar, setShowRadar, showFlightPath, setShowFlightPath, showGeoFence, setShowGeoFence, showSafePort, setShowSafePort, showNoFlyZone, setShowNoFlyZone, } = useMonitorMap();
    return (React.createElement(Paper, { variant: "outlined", sx: { p: 3 / 4 } },
        React.createElement(Stack, { gap: 1 / 4 },
            enableRadar ? (React.createElement(React.Fragment, null,
                React.createElement(Row, { color: Palette.Path, label: intl.formatMessage(msgs.textFootprint), enabled: interactive ? showFootprint : true, onToggle: interactive ? () => setShowFootprint?.(!showFootprint) : undefined }),
                React.createElement(Row, { color: Palette.Radar, label: intl.formatMessage(msgs.textRadar), enabled: interactive ? showRadar : true, onToggle: interactive ? () => setShowRadar?.(!showRadar) : undefined }))) : null,
            React.createElement(Row, { color: Palette.FlightPath, label: intl.formatMessage(msgs.textFlightPath), fill: true, enabled: interactive ? showFlightPath : true, onToggle: interactive ? () => setShowFlightPath?.(!showFlightPath) : undefined }),
            React.createElement(Row, { color: Palette.GeoFence, label: intl.formatMessage(msgs.textGeoFence), fill: true, enabled: interactive ? showGeoFence : true, onToggle: interactive ? () => setShowGeoFence?.(!showGeoFence) : undefined }),
            React.createElement(Row, { color: Palette.SafePort, label: intl.formatMessage(msgs.textSafePort), fill: true, enabled: interactive ? showSafePort : true, onToggle: interactive ? () => setShowSafePort?.(!showSafePort) : undefined }),
            React.createElement(Row, { color: Palette.NoFlyZone, label: intl.formatMessage(msgs.textNoFlyZone), fill: true, enabled: interactive ? showNoFlyZone : true, onToggle: interactive ? () => setShowNoFlyZone?.(!showNoFlyZone) : undefined }))));
}
export default MapLegend;
